/**
 * Die letzte Folge von ZweiOnCTI, auf der Startseite.
 *
 * Das Spiel kommt von CICS und ZweiOnCTI, und wer hier Floskeln markiert,
 * ist genau das Publikum des Podcasts. Ein Klick fuehrt hinaus: zur Folge,
 * zu Spotify oder zu Apple. Abgespielt wird hier nichts, das koennen die
 * drei besser.
 */
import { useEffect, useState } from 'react'

import { useLang } from '../lang'
import { api } from '../lib/api'

interface Payload {
  show: string
  claim: string
  siteUrl: string
  spotifyUrl: string
  appleUrl: string
  episode: {
    title: string
    link: string
    published: string
    summary: string
    duration: string
    number: string
    season: string
  } | null
}

export function Podcast() {
  const { t, lang } = useLang()
  const [data, setData] = useState<Payload | null>(null)

  useEffect(() => {
    api.get<Payload>('/podcast').then(setData).catch(() => setData(null))
  }, [])

  if (!data) return null
  const { episode } = data
  // Der beste Link, den es gibt. Riverside liefert keinen je Folge, also
  // fuehrt der Klick zur Show: dort steht die neueste Folge ohnehin oben.
  const ziel = episode?.link || data.spotifyUrl || data.appleUrl || data.siteUrl
  if (!ziel && !episode) return null

  const datum = episode?.published ? new Date(episode.published) : null
  const gueltig = datum && !Number.isNaN(datum.getTime())

  return (
    <section className="card stack">
      <div className="row row--between">
        <div className="kicker">{t('podcast.kicker')}</div>
        <span className="tag">{data.claim}</span>
      </div>

      {episode ? (
        <a className="podcast" href={ziel} target="_blank" rel="noopener noreferrer">
          <div className="podcast__meta">
            {episode.number ? <span>{t('podcast.episode', { n: episode.number })}</span> : null}
            {gueltig ? <span>{datum.toLocaleDateString(lang === 'en' ? 'en-GB' : 'de-CH')}</span> : null}
            {episode.duration ? <span>{episode.duration}</span> : null}
          </div>
          <strong className="podcast__title">{episode.title}</strong>
          {episode.summary ? <p className="podcast__summary">{episode.summary}</p> : null}
          <span className="podcast__go">{t('podcast.listen')} &rarr;</span>
        </a>
      ) : (
        <p className="muted small">{t('podcast.noEpisode')}</p>
      )}

      <div className="row" style={{ flexWrap: 'wrap' }}>
        {data.spotifyUrl ? (
          <a className="btn btn--ghost" href={data.spotifyUrl} target="_blank" rel="noopener noreferrer">
            Spotify
          </a>
        ) : null}
        {data.appleUrl ? (
          <a className="btn btn--ghost" href={data.appleUrl} target="_blank" rel="noopener noreferrer">
            Apple Podcasts
          </a>
        ) : null}
        {data.siteUrl ? (
          <a className="btn btn--ghost" href={data.siteUrl} target="_blank" rel="noopener noreferrer">
            {t('podcast.allEpisodes')}
          </a>
        ) : null}
      </div>
    </section>
  )
}
